import { ViewRecordsPopup } from '@aibees/elephant/components/view-records-popup';
import { useViewRecordsPopoverStore } from '@aibees/elephant/store/view-records-popover';
import { useMediaQuery } from '@mui/material';
import { memo, useCallback, useEffect } from 'react';
import { ViewRecordButton } from './view-record-button';

export const ViewRecords = memo(function ViewRecords() {
  const popoverState = useViewRecordsPopoverStore();
  const isSmall = useMediaQuery('(max-width:1200px)');

  // Zustand action refs are stable; deps array is correct as-is.
  useEffect(() => {
    popoverState.setCompact(isSmall);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [popoverState.setCompact, isSmall]);

  const handleOpen = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      popoverState.onOpen(e.currentTarget);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [popoverState.onOpen]
  );

  return (
    <>
      <ViewRecordButton
        onOpen={handleOpen}
        isOpen={!!popoverState.open}
        compact={popoverState.compact}
      />
      {popoverState.open && (
        <ViewRecordsPopup state={popoverState} type="lists" /> //view records popup
      )}
    </>
  );
});
